import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { provideStore } from '@ngxs/store';
import { routes } from 'src/app/core/routes/app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import HubWebTheme from 'src/theme/theme';
import { provideHttpClient, withFetch, withJsonpSupport, withInterceptors } from '@angular/common/http';
import { authenticationInterceptor } from 'src/app/core/interceptors/authentication.interceptor';
import { loggingInterceptor } from 'src/app/core/interceptors/logging.interceptor';
import { OPTIONS_CONFIG, STATES } from 'src/app/shared/store/store.config';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsLoggerPlugin } from '@ngxs/logger-plugin';
import { provideTransloco } from '@jsverse/transloco';
import { translocoConfig } from 'src/app/transloco/transloco.config';
import { TranslocoHttpLoader } from 'src/app/transloco/transloco.loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withJsonpSupport(), withInterceptors([authenticationInterceptor, loggingInterceptor])),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: HubWebTheme,
        options: {
          darkModeSelector: false,
        }
      }
    }),
    provideStore(STATES, OPTIONS_CONFIG, withNgxsReduxDevtoolsPlugin(), withNgxsLoggerPlugin()),
    provideTransloco({
      config: translocoConfig,
      loader: TranslocoHttpLoader
    }),
  ]
};

